import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module clipboard/lineview
 */
/* istanbul ignore file -- @preserve */
import { View } from '@ckeditor/ckeditor5-ui';
import { toUnit } from '@ckeditor/ckeditor5-utils';
var toPx = toUnit('px');
/**
 * The horizontal drop target line view.
 */
var LineView = /*#__PURE__*/function (_View) {
  _inherits(LineView, _View);
  var _super = _createSuper(LineView);
  /**
   * @inheritDoc
   */
  function LineView() {
    var _this;
    _classCallCheck(this, LineView);
    _this = _super.call(this);
    var bind = _this.bindTemplate;
    _this.set({
      isVisible: false,
      left: null,
      top: null,
      width: null
    });
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-clipboard-drop-target-line', bind.if('isVisible', 'ck-hidden', function (value) {
          return !value;
        })],
        style: {
          left: bind.to('left', function (left) {
            return toPx(left);
          }),
          top: bind.to('top', function (top) {
            return toPx(top);
          }),
          width: bind.to('width', function (width) {
            return toPx(width);
          })
        }
      }
    });
    return _this;
  }
  return LineView;
}(View);
export { LineView as default };